import React from 'react'
import { SIDE_NAV_WIDTH, SIDE_NAV_COLLAPSED_WIDTH, NAV_TYPE_TOP } from 'constants/ThemeConstant';
import { APP_NAME } from 'configs/AppConfig';
import { connect } from "react-redux";
import utils from 'utils';
import { Grid } from 'antd';

const { useBreakpoint } = Grid;

const getLogoWidthGutter = (props, isMobile) => {
  const { navCollapsed, navType } = props;
  const isNavTop = navType === NAV_TYPE_TOP ? true : false
  if(isMobile && !props.mobileLogo) {
    return 0
  }
  if(isNavTop) {
    return 'auto'
  }
  if(navCollapsed) {
    return `${SIDE_NAV_COLLAPSED_WIDTH}px`
  } else {
    return `${SIDE_NAV_WIDTH}px`
  }
}

const getLogo = (props) => {
  const { navCollapsed, logoType } = props;
  // ¿ Obtener id del proyecto
  const rawData = window.localStorage.getItem('PRIMARY_DATA')
  const data = JSON.parse(rawData)
  var projectId = data.Firebase.projectId
  var folder = '/img/logos-' + projectId

  // ¿ Revisar si el proyecto tiene logos
  if(projectId !== "escs-logistica" 
    && projectId !== "inacap-logistica" 
    && projectId !== "duoc-logistica" 
    && projectId !== "aiep-logistica" 
    && projectId !== "udp-logistica" 
    && projectId !== "sqm-quimica" 
    && projectId !== "cft-tarapaca-logistica"
    && projectId !== "unilever-extintores")
    folder = "/img"

  if(logoType === 'light') {
    if(navCollapsed) {
      return folder + '/logo-sm-white.png'
    }
    return folder + '/logo-white.png'
  }

  if (navCollapsed) {
    return folder + '/logo-sm.png'
  }
  return folder + '/logo.png'
}

const getLogoDisplay = (isMobile, mobileLogo) => {
  if(isMobile && !mobileLogo) {
    return 'd-none'
  } else {
    return 'logo'
  }
}

export const Logo = (props) => {
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg')
  return (
    <div
      className={getLogoDisplay(isMobile, props.mobileLogo)} 
      style={{width: `${getLogoWidthGutter(props, isMobile)}`}}>
      <img src={getLogo(props)} alt={`${APP_NAME} logo`}/>
    </div>
  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType } =  theme;
  return { navCollapsed, navType }
};

export default connect(mapStateToProps)(Logo);
